module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r3r4n8n-5164a60b025cf3e099559db60ad51819.svg";